<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { Toast, Notify } from 'vant'
import { CHECK_JURISDICTION_URL_LIST, ADVERTISEMENT_PAGE } from '@/assets/config.js'
export default {
  name: 'app',
  components: {
    [Toast.name]: Toast
  },
  watch: {
    async '$route' (to, form) {
      Toast.loading({
        message: '加载中...',
        duration: 0,
        forbidClick: true
      })
      const { path } = to
      const { path: formPath } = form
      try {
        // 如果访问了需要广告的页面，需要查一下广告
        if (ADVERTISEMENT_PAGE.includes(path)) {
          window.TencentGDTQueryNum = 0
          if (window.TencentGDTTime) {
            window.TencentGDTTime = null
            clearTimeout(window.TencentGDTTime)
          }
          if (window.TencentGDT) {
            window.TencentGDT.NATIVE.loadAd(window.TencentGDTId)
          }
        }
        const arr = CHECK_JURISDICTION_URL_LIST
        let menuList = this.$store.state.user && this.$store.state.user.menuList ? this.$store.state.user.menuList : []
        // 如果访问的时需要鉴权的页面,并且有异常情况导致权限列表为空，重查一次
        if (arr.includes(path) && !menuList.length) {
          const newMenu = await this.$store.dispatch({
            type: 'user/getJurisdiction'
          })
          menuList = newMenu || []
        }
        if (arr.includes(path) && !menuList.find(i => i.moduleUrl === path)) {
          Notify({ type: 'danger', message: '当前功能暂未开通权限，请联系管理员' })
          if (window.location.pathname !== formPath) {
            Toast.clear({
              clearAll: true
            })
            this.$router.replace(formPath)
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        Toast.clear({
          clearAll: true
        })
      }
    }
  }
}
</script>

<style lang="less">
@import './assets/style/global.less';

body {
  background-color: #fff;
  font-family: 'PingFang SC';
}
.tip-dialog{
  z-index: 9000 !important;
}
</style>
